// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/transportation_result.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_transportation_transportation } from "../feature/transportation/transportation_pb";

/**
 * Describes the file proto/model/search/transportation_result.proto.
 */
export const file_proto_model_search_transportation_result = /*@__PURE__*/
  fileDesc("Ci5wcm90by9tb2RlbC9zZWFyY2gvdHJhbnNwb3J0YXRpb25fcmVzdWx0LnByb3RvEgZjYXJtZW4iPAoUVHJhbnNwb3J0YXRpb25SZXN1bHQSJAoJaXRpbmVyYXJ5GAEgASgLMhEuY2FybWVuLkl0aW5lcmFyeUIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_proto_model_feature_transportation_transportation]);

/**
 * Describes the message carmen.TransportationResult.
 * Use `create(TransportationResultSchema)` to create a new message.
 */
export const TransportationResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_transportation_result, 0);

